import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledIcon = styled.img`
  height: 100px;
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 4.5em;

  ${themeMedia.tablet`
    width: 500px;
    margin: 0 auto;
  `};
`
export const StyledInfoText = styled.div`
  font-size: 1em;
  padding: 2rem 0 0 0;
  text-align: center;
  a {
    color: initial;
  }
  ${themeMedia.desktop`
    font-size: 1.0em;
    padding: 1rem 0 0 0;

  `};
`
export const StyledTextIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 24.5px;
`

export const StyledCheckboxWrapper = styled.div`
  padding: 3rem 0 0 0;

  div {
    font-size: 1em;
    align-items: center;
  }

  ${themeMedia.desktop`
    padding: 2rem 0 0 0;

    div {
      font-size: 1em;
      align-items: center;
    }
  `};
`
